export  enum SpecialEventType{
  NoScreening = 0,
  NoScreeningWithPostEvent = 1,
  Screening = 2,
  ScreeningWithPreEvent = 3,
  ScreeningWithPostEvent = 4,
  ScreeningWithPreAndPostEvent = 5
}

export  enum ScheduleWarningType{
  SpecialEventInvalidDateVenue = 1
}
